module.exports = __webpack_public_path__ + "static/media/pump-circle-red.52c16502.png";